import { createBrowserRouter } from "react-router-dom";
import Sports from "../containers/sports";
import PayementSuccessPage from "../containers/paymentSuccess";
import LoginPage from "../containers/auth/login";
import ErrorPage from "../containers/Error";
import StartPage from "../containers";
import MainLayout from "../containers/mainWrapper";
import ClubBookings from "../containers/clubbookings";
import MasterFacilities from "../containers/clubSetup/masterFacilities";
import ClubCustomers from "../containers/clubCustomers";
import Clubs from "../containers/clubs";
import LevelThreshold from "../containers/setup/levelThresholds";
import Countries from "../containers/setup/countries";
import States from "../containers/setup/states";
import Cities from "../containers/setup/cities";
import Courts from "../containers/courts";
import AddCourt from "../containers/courts/addCourt";
import AddCourtHoliday from "../containers/courts/courtHolidays/addCourtHoliday";
import CourtHolidays from "../containers/courts/courtHolidays";
import Transactions from "../containers/transactions";
import TransactionLogs from "../containers/transactions/logs";
import BooingDetails from "../containers/clubbookings/bookingDetails/bookingDetails";
import Tournaments from "../containers/tournament";
import AddTournament from "../containers/tournament/addTournament";
import TournamentRules from "../containers/tournament/rules";
import TournamentGrouping from "../containers/tournament/grouping";
import BookingCalendar from "../containers/clubbookings/calendar/calendar";
import AddSport from "../containers/sports/addSport";
import Scheduling from "../containers/tournament/scheduling/index";
import ViewSchedules from "../containers/tournament/viewschedules/index";
import Dashboard from "../containers/dashboard";
import ClubSettings from "../containers/clubSettings";
import PromoCode from "../containers/promoCode";
import SportQuestions from "../containers/questions";
import AddQuestion from "../containers/questions/components/addQuestion";
import ClubDetails from "../containers/clubDetails";
import PayMethodAdminSetup from "../containers/paymethod/paymethodAdminSetup";
import AddAccount from "../containers/clubAccounts/addAccount";
import ClubAccount from "../containers/clubAccounts";
import Notifications from "../containers/notifications";
/*import AddNotifications from "../containers/notifications/components/addNotifications";*/
import ResourceCalendar from "../components/ui/bigcalendar";
import BookingCalendar2 from "../containers/bookingcalendar";
import Error404 from "../containers/auth/404";
import Error403 from "../containers/auth/403";
import AddPromoCodes from "../containers/promoCodes/addPromoCodes";
import PromoCodesDetail from "../containers/promoCodes/promoCodesDetail";
import PromoCodes from "../containers/promoCodes";
import PayementFailurePage from "../containers/paymentFailed";

import AddClubHoliday from "../containers/clubs/clubHolidays/addClubHoliday";
import ClubHolidays from "../containers/clubs/clubHolidays";
import PaymentAccountBalance from "../containers/reports/paymentAccountBalance";
import Balance from "../containers/reports/balance";
import TodayBookingCalendar from "../containers/todaybookingcalendar";

import AddPayments from "../containers/payments/addPayments";
import Payments from "../containers/payments";
import AddAdjustment from "../containers/adjustment/addAdjustment";
import Adjustment from "../containers/adjustment";
import AdjustmentLog from "../containers/adjustment/adjustmentLog";

import POSSystem from "../containers/pos";
import POSOrderDetails from "../containers/pos/orderDetails";
import POSOrdersList from "../containers/pos/ordersList";
import StockLogs from "../containers/pos/stockLogs";
//import POSOrderDetails from "../containers/pos/orderDetails";
//import POSOrdersList from "../containers/pos/ordersList";
//import StockLogs from "../containers/pos/stockLogs";
import ClubSetups from "../containers/clubSettingSetup";
import Expenses from "../containers/expenseSetup/expense";
import ExpenseAccounts from "../containers/expenseSetup/expenseAccount";
import Amenities from "../containers/amenities";
import Products from "../containers/products";
import ProductCategories from "../containers/products/categories";
import StockManagement from "../containers/stockManagement";
//import Products from "../containers/products";
//import ProductCategories from "../containers/products/categories";
//import StockManagement from "../containers/stockManagement";

import MasterTournaments from "../containers/tournament/masterTournament";
import TournamentUmpires from "../containers/tournament/umpires";
import ContactUs from "../containers/contactUs/index";
import Analytics from "../containers/analytics";
import AddUserNotifications from "../containers/notifications/userNotification";
import CheckUserExistance from "../containers/user/checkuserexistance";
import Teaming from "../containers/tournament/teaming";
import TournamentCalculator from "../containers/tournament/tournamentCalculator";

// Application Users
// import Users from "../containers/users";
// import AddUser from "../containers/users/addUser";
import Users from "../containers/applicationUsers";
import AddUser from "../containers/applicationUsers/addUser";
import AddOtherUser from "../containers/applicationUsers/addOtherUser";

import AddMultiBooking from "../containers/clubbookings/addmultibooking";
import NotificationConfigs from "../containers/notificationconfigs";
import Banks from "../containers/setup/banks";
import POSMachines from "../containers/setup/posmachines";
import POSMachineGLFields from "../containers/setup/posmachines/glFields";
import BankCards from "../containers/setup/bankcards";
import BankCardCategories from "../containers/setup/bankcardcategories";
import BankDiscounts from "../containers/bankdiscounts";
import AddBankDiscount from "../containers/bankdiscounts/addBankDiscount";
import ClubUsers from "../containers/clubusers";
import AddClubUser from "../containers/clubusers/addClubUser";
import ClubAmenities from "../containers/clubAmenities";
import AmenityBookings from "../containers/amenityBookings";
import AddAmenityBooking from "../containers/amenityBookings/addAmenityBooking";
import AmenityBookingDetails from "../containers/amenityBookings/amenityBookingDetails";
import TermsnConditions from "../containers/TermsnConditions";
import DiscountLogs from "../containers/bankdiscounts/discountLogs";
import OffPeaks from "../containers/offPeakSetup";
import RankingCategories from "../containers/rankings/rankingcategories";
import RankingPoints from "../containers/rankings/rankingpoints";
import Sliders from "../containers/sliderSetup";
import AdminClubAccounts from "../containers/adminClubAccounts";
import AdminAddAccount from "../containers/adminClubAccounts/adminAddAccount";
import UpdateProfile from "../containers/profile/editprofile";
import ClubPermissions from "../containers/clubPermissions";
import MasterPermissions from "../containers/masterPermissions";
import AddRoutes from "../containers/masterPermissions/addRoutes";
import GlobalPermissions from "../containers/globalRolePermission";
import ClubAccountsAdmin from "../containers/adminClubAccounts";
//import AdminAddAccount from "../containers/adminClubAccounts/addAccountAdmin";
import BinNumbers from "../containers/binsetup";
import ClubHolidayRecurrings from "../containers/clubHolidayRecurrings";
import AddClubHolidayRecurring from "../containers/clubHolidayRecurrings/addClubHolidayRecurring";

import Logs from "../containers/logs/notificationlogs";
import BookingReport from "../containers/reports/bookingReport";

import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { loader } from "react-global-loader";
import React from "react";
import common from "../helper/common";
import Swal from "sweetalert2";
import { isUserManagementEnabled } from "../constants/appConstant";
import LayoutLoader from "../components/layout-loader";
import BlackListCustomers from "../containers/blackListCustomers";

import BookingCancellationReasons from "../containers/bookingCancellationReasons";
import AdminDashboard from "../containers/adminDashboard";
import ClientUsers from "../containers/clientUserManagement";
import AddClientUser from "../containers/clientUserManagement/addClientUser";
import ExternalCred from "../containers/externalCred";
import ExternalSyncingLog from "../containers/externalSyncingLog";

// Open Matches
import OpenMatches from "../containers/openMatches";
import CreateMatch from "../containers/openMatches/createMatch";
import MatchDetails from "../containers/openMatches/matchDetails";
import ManagerScreen from "../containers/openMatches/managerScreen";
import OpenMatchClub from "../containers/openMatches/openMatchClub";
import OpenMatchCategory from "../containers/openMatches/openMatchCategory";
import StockLogDetails from "../containers/pos/stockLogDetails";

// Americano
import Americanos from "../containers/americano";
import CreateAmericano from "../containers/americano/createAmericano";
import AmericanoDetails from "../containers/americano/americanoDetails";

//Tax
import Tax from "../containers/taxes";
import TaxLogs from "../containers/taxes/taxLogs";



const errorElement = <ErrorPage />;

// Loading component for when routes are being built
const LoadingRoute = () => <LayoutLoader />;

export const routeComponentMap = {
  dashboard: Dashboard,
  sports: Sports,
  addSport: AddSport,
  "external-cred": ExternalCred,
  "external-syncing-log": ExternalSyncingLog,
  clubbookings: ClubBookings,
  calendar: BookingCalendar,
  todaycalendar: TodayBookingCalendar,
  bookingDetails: BooingDetails,
  facilities: MasterFacilities,
  clubcustomers: ClubCustomers,
  clubs: Clubs,
  levelthreshold: LevelThreshold,
  countries: Countries,
  states: States,
  cities: Cities,
  courts: Courts,
  addCourt: AddCourt,
  courHolidays: CourtHolidays,
  addCourtHoliday: AddCourtHoliday,
  transactions: Transactions,
  transactionLogs: TransactionLogs,
  tournaments: Tournaments,
  addTournament: AddTournament,
  tournamentGrouping: TournamentGrouping,
  tournamentScheduling: Scheduling,
  tournamentViewSchedules: ViewSchedules,
  clubsetup: ClubSettings,
  promoCode: PromoCode,
  questions: SportQuestions,
  addQuestion: AddQuestion,
  clubDetails: ClubDetails,
  adminPayMethod: PayMethodAdminSetup,
  addAccount: AddAccount,
  clubAccounts: ClubAccount,
  bigCalendar: ResourceCalendar,
  bookingcalendar: BookingCalendar2,
  addpromocodes: AddPromoCodes,
  promocodes: PromoCodes,
  promocodesdetail: PromoCodesDetail,
  clubholidays: ClubHolidays,
  addclubholiday: AddClubHoliday,
  paymentaccountbalance: PaymentAccountBalance,
  balance: Balance,
  notification: Notifications,
  addpayments: AddPayments,
  payments: Payments,
  addAdjustment: AddAdjustment,
  adjustments: Adjustment,
  adjustmentlog: AdjustmentLog,
  pos: POSSystem,
  ClubSetups: ClubSetups,
  clubsetups: ClubSetups,
  expenses: Expenses,
  sliders: Sliders,
  expenseaccounts: ExpenseAccounts,
  amenities: Amenities,
  products: Products,
  "products/categories": ProductCategories,
  stock: StockManagement,
  clubamenities: ClubAmenities,
  amenitybookings: AmenityBookings,
  addamenitybooking: AddAmenityBooking,
  amenitybookingdetails: AmenityBookingDetails,
  tournamentRules: TournamentRules,
  mastertournaments: MasterTournaments,
  tournamentumpires: TournamentUmpires,
  contactus: ContactUs,
  users: Users,
  usernotification: AddUserNotifications,
  checkuserexistance: CheckUserExistance,
  tournamentteaming: Teaming,
  tournamentcalculator: TournamentCalculator,
  adduser: AddUser,
  addmultibooking: AddMultiBooking,
  notificationconfigs: NotificationConfigs,
  clubconfig: NotificationConfigs,
  banks: Banks,
  posmachines: POSMachines,
  "posmachines/gl-fields": POSMachineGLFields,
  bankcards: BankCards,
  bankcardcategories: BankCardCategories,
  bankdiscounts: BankDiscounts,
  discountlogs: DiscountLogs,
  offpeaks: OffPeaks,
  addbankdiscount: AddBankDiscount,
  clubusers: ClubUsers,
  addclubuser: AddClubUser,
  analytics: Analytics,
  termsnConditions: TermsnConditions,
  clubpermissions: ClubPermissions,
  masterpermissions: MasterPermissions,
  addroutes: AddRoutes,
  globalpermissions: GlobalPermissions,
  addotheruser: AddOtherUser,
  "pos-orders": POSOrdersList,
  "pos-order-details": POSOrderDetails,
  "stock-logs": StockLogs,
  rankingcategories: RankingCategories,
  rankingpoints: RankingPoints,
  adminClubAccounts: AdminClubAccounts,
  adminAddAccount: AdminAddAccount,
  clubAccountsAdmin: ClubAccountsAdmin,
  editprofile: UpdateProfile,
  notificationlogs: Logs,
  bins: BinNumbers,
  blacklistcustomers: BlackListCustomers,
  clubholidayrecurrings: ClubHolidayRecurrings,
  addclubholidayrecurring: AddClubHolidayRecurring,
  bookingreport: BookingReport,
  bookingcancellationreasons: BookingCancellationReasons,
  admindashboard: AdminDashboard,
  openmatches: OpenMatches,
  "openmatches/create": CreateMatch,
  "openmatches/details": MatchDetails,
  "openmatches/manager": ManagerScreen,
  //Client User Management
  clientusers: ClientUsers,
  addclientuser: AddClientUser,
  //Americano
  americanos: Americanos,
  "americano/create": CreateAmericano,
  "americano/details": AmericanoDetails,
  openmatchclub: OpenMatchClub,
  openmatchcategory: OpenMatchCategory,

  
  stocklogdetails:StockLogDetails,
   taxes:Tax,
  taxlogs:TaxLogs,
  
 
};

// Generate static routes
const staticAppChildrenRoutes = Object.entries(routeComponentMap).map(
  ([path, Component], index) => ({
    id: `static-${path.replace(/[^a-zA-Z0-9]/g, "-")}-${index}`,
    path,
    element: <Component />,
  })
);

// created Protected wrapper to inject premium feature access
const ProtectedRoute = ({ pathKey, children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = common.getUser()?.menus || [];
  const match = permissions.find(
    (p) =>
      p.endpoint?.replace("/app/", "").replace(/^\//, "").split("?")[0] ===
      pathKey
  );

  if (match?.premiumallowed == 0) {
    Swal.fire({
      title: "Premium Feature",
      text: "This feature is available only in the premium plan. If you would like to upgrade, please contact our sales team at +92 334 3355003 or email us at support@playpro.pk for more information.",
      icon: "warning",
      showCancelButton: false,
      //cancelButtonText: "Not Now",
      confirmButtonText: "Not Now",
      confirmButtonColor: "#0C1B3A",
      iconColor: "#f1c40f",
      allowOutsideClick: true,
      backdrop: true,
    }).then((result) => {
      //if (result.isConfirmed) {
      //  navigate("/app/dashboard");
      //} else {
      navigate(-1);
      //}
    });
  }
  return children;
};

const generateDynamicRoutes = async () => {
  const user = common.getUser();

  // If user or menus not loaded yet, show loader
  if (!user || !user.menus || user.menus.length === 0) {
    //loader.show();
    return [];
  }

  //loader.hide(); // Once menus are ready, hide loader

  const permissions = user.menus;
  const uniquePaths = new Set();
  return permissions
    .filter((p) => p.endpoint?.startsWith("/app/"))
    .map((p) => {
      const rawPath = p.endpoint
        .replace("/app/", "")
        .replace(/^\//, "")
        .split("?")[0];
      if (uniquePaths.has(rawPath)) return null;
      uniquePaths.add(rawPath);

      const component = routeComponentMap[rawPath];
      if (!component) return null;

      return {
        id: `dynamic-${rawPath.replace(/[^a-zA-Z0-9]/g, "-")}`,
        path: rawPath,
        element: (
          <ProtectedRoute pathKey={rawPath}>
            {React.createElement(component)}
          </ProtectedRoute>
        ),
      };
    })
    .filter(Boolean);
};

export async function rebuildAppRouter() {
  try {
    const newDynamicRoutes = await generateDynamicRoutes();
    const appRoute = router.routes.find((r) => r.path === "/app");
    if (appRoute) {
      appRoute.children = [
        ...newDynamicRoutes,
        {
          id: "dynamic-not-found",
          path: "*",
          element: <Navigate to="/404" replace />,
        },
      ];
      console.log(
        "Router rebuilt with",
        newDynamicRoutes.length,
        "dynamic routes"
      );
    }
  } catch (error) {
    console.error("Error rebuilding router:", error);
  }
}

// Function to get initial app routes
const getInitialAppRoutes = () => {
  if (!isUserManagementEnabled) {
    return [
      ...staticAppChildrenRoutes,
      {
        id: "app-not-found",
        path: "*",
        element: <Navigate to="/404" replace />,
      },
    ];
  }

  // For user management enabled, try to get initial routes
  const user = common.getUser();
  if (user?.menus?.length > 0) {
    // Try to generate initial routes
    const permissions = user.menus;
    const uniquePaths = new Set();
    const initialRoutes = permissions
      .filter((p) => p.endpoint?.startsWith("/app/"))
      .map((p) => {
        const rawPath = p.endpoint
          .replace("/app/", "")
          .replace(/^\//, "")
          .split("?")[0];
        if (uniquePaths.has(rawPath)) return null;
        uniquePaths.add(rawPath);

        const component = routeComponentMap[rawPath];
        if (!component) return null;

        return {
          id: `initial-${rawPath.replace(/[^a-zA-Z0-9]/g, "-")}`,
          path: rawPath,
          element: (
            <ProtectedRoute pathKey={rawPath}>
              {React.createElement(component)}
            </ProtectedRoute>
          ),
        };
      })
      .filter(Boolean);

    return [
      ...initialRoutes,
      {
        id: "initial-not-found",
        path: "*",
        element: <Navigate to="/404" replace />,
      },
    ];
  }

  // Fallback to loading route
  return [
    {
      id: "loading-route",
      path: "*",
      element: <LoadingRoute />,
    },
  ];
};

export const router = createBrowserRouter([
  {
    id: "root",
    path: "/",
    element: <StartPage />,
    errorElement,
  },
  {
    id: "login",
    path: "/login",
    element: <LoginPage />,
    errorElement,
  },
  {
    id: "login-uppercase",
    path: "/Login",
    element: <LoginPage />,
    errorElement,
  },
  {
    id: "payment-success",
    path: "/PaymentSuccess",
    element: <PayementSuccessPage />,
    errorElement,
  },
  {
    id: "payment-failed",
    path: "/PaymentFailed",
    element: <PayementFailurePage />,
    errorElement,
  },
  {
    id: "error-404",
    path: "/404",
    element: <Error404 />,
  },
  {
    id: "error-403",
    path: "/403",
    element: <Error403 />,
  },
  {
    id: "app",
    path: "/app",
    element: <MainLayout />,
    errorElement,
    children: getInitialAppRoutes(),
  },
]);
